// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

class InstagramFeed extends WebComponent {
	constructor(props) {
		super(props);
	}

	didMount() {
		const igFeedContainer = document.querySelector('.instagram-feed');
		const userID = 'fgforrestcz'; // it can be user name as well
		const amountOfItems = 4; // 12 max

		const xhr = new XMLHttpRequest();
		xhr.onload = function () {
			if ( xhr.status >= 200 && xhr.status < 300 ) {
				const response = JSON.parse(xhr.response);
				const allPosts = response.graphql.user.edge_owner_to_timeline_media.edges;
				// slicing to requested amount
				const posts = allPosts.slice(0, amountOfItems);
				let postsHTML = '';

				for ( let i = 0; i < posts.length; i++ ) {
					const shortcode = posts[ i ].node.shortcode;
					const imageUrl = posts[ i ].node.thumbnail_resources[4].src;
					const postCaption = posts[ i ].node.edge_media_to_caption.edges[ 0 ].node.text;

					postsHTML +=
						`<a class="instagram-feed__item" href="https://www.instagram.com/p/${ shortcode }" target="_blank" rel="noopener"><img class="instagram-feed__image" src="${ imageUrl }" width="320" height="320" alt="${ postCaption }" /></a>`;
				}
				igFeedContainer.insertAdjacentHTML('beforeend', postsHTML);
			} else {
				console.log('Obsah se nepodařilo načíst. Kontaktuje prosím správce webu.');
			}
		};
		xhr.open('GET', `https://www.instagram.com/${ userID }?__a=1`);
		xhr.send();
	}
}

export default InstagramFeed;



// WEBPACK FOOTER //
// ./fe/web-uhkPoint/src/js/components/InstagramFeed.js